module.exports = {"id":"190195","name":"Mamadou Samassa","rating":"74","photo":"./data/images/photos/0/190195.png","club":{"name":"ESTAC Troyes","logo":"./data/images/clubs/ESTACTroyes.png"},"positions":["G"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/MamadouSamassa0.json
// module id = 2668
// module chunks = 0